export class VAChatService {
    constructor() {
        this.send = async (body) => {
            const location = window.location.href;
            let subdomain = 'wgvbmart-18.qa';
            if (/^https?:\/\/www\.ameriprise\.com\//.test(location)) {
                subdomain = 'wgvbmart-18';
            }
            else if (/^https?:\/\/www-preprod\.ameriprise\.com\//.test(location)) {
                subdomain = 'wgvbmart-18-b';
            }
            return fetch(`https://${subdomain}.ameriprise.com/smc.svc/sendPubUserVAChatMessage`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    consumer: 'id=A0056099-8CC7YJYS05J7L89Y;type=WEB'
                },
                body: JSON.stringify(body)
            })
                .then(resp => {
                return resp.json();
            })
                .catch(() => {
                throw new Error(`VAChatService send failed.`);
            });
        };
    }
}
